<template>
  <div class="modal-content">
    <form class="form-horizontal needs-validation" novalidate id="formEditReceiveDetail">
      <div class="modal-header">
        <h5 class="modal-title" id="ReceiveDetailModalLabel">Edit Stock In Detail</h5>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label class="col-md-12">Supplier</label>
            <div class="col-md-12 mb-3">
              <p>{{ modalDataEdit.supplier }}</p>
            </div>
            <label class="col-md-12">Part Store</label>
            <div class="col-md-12 mb-3">
              <p>{{ modalDataEdit.partstore }}</p>
            </div>
          </div>
          <div class="col-sm-6 ">
            <label class="col-md-12">QTY</label>
            <div class="col-md-12">
              <input type="number" v-model="modalDetailEdit.recd_qty" class="form-control" onClick="this.select();" placeholder="enter qty" required />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-fix" @click="closeModal"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-info btn-fix" @click="checkForm"><i class="fas fa-save"></i> Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../../models/receive'

export default {
  props: ['modalDetailEdit', 'modalDataEdit', 'reloadDetailPagination'],
  data() {
    return {}
  },
  methods: {
    checkForm() {
      var $myForm = $('#formEditReceiveDetail')
      if (!$myForm[0].checkValidity()) {
        $('#formEditReceiveDetail').addClass('was-validated')
      } else {
        this.editReceiveDetail()
      }
    },
    closeModal() {
      $('#ReceiveDetailModal').modal('hide')
    },
    editReceiveDetail() {
      $('#ReceiveDetailModal').modal('hide')
      let formData = {
        recd_id: this.modalDetailEdit.recd_id,
        recd_qty: this.modalDetailEdit.recd_qty
      }
      // console.log(formData)
      api.editReceiveDetail(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.reloadDetailPagination()
            this.alert_msg('success', 'Edit Receive Detail', result.message)
          } else {
            this.reloadDetailPagination()
            this.alert_msg('warning', 'Edit Receive Detail', result.message)
          }
        },
        error => {
          this.reloadDetailPagination()
          this.alert_msg('error', 'Edit Receive Detail', error.message)
        }
      )
    }
  },
  mounted() {
    $('#ReceiveDetailModal').on('show.bs.modal', event => {
      if (event.target.id === 'ReceiveDetailModal') {
        $('#formEditReceiveDetail').removeClass('was-validated')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/receive_detail_edit_modal.vue